import { Injectable, Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DialogOverviewComponent } from 'src/app/components/dialog-overview/dialog-overview.component';
import { DialogOverviewDeleteOrganizationComponent } from 'src/app/components/dialog-overview-delete-organization/dialog-overview-delete-organization.component';
import { Router, RoutesRecognized } from '@angular/router';
import { filter, pairwise } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';


import { Organization } from 'src/app/@core/models/infrastructure/Organization.model';
import { Infrastructure } from 'src/app/@core/models/infrastructure/Infrastructure.model';
import { DarkModeService } from '../dark-mode/dark-mode.service';

@Injectable({
  providedIn: 'root'
})
export class AppService {
  @Input() organization: Organization;

  public title = 'Configuración del pricing dinámico';

  public back = '';

  public loading: boolean;

  public previousUrl = '';

  constructor(public dialog: MatDialog, public router: Router, public translateService: TranslateService, public darkModeService: DarkModeService) {
    this.router.events
      .pipe(filter((evt: any) => evt instanceof RoutesRecognized), pairwise())
      .subscribe((events: RoutesRecognized[]) => {
        this.previousUrl = events[0].urlAfterRedirects;
        // document.querySelector('div.mat-toolbar').scrollIntoView();
      });
  }

  // tslint:disable-next-line: ban-types
  openDialogDeleteOrganization(title?: string, message?: string, infrastructure?: Infrastructure, ok?: Function, cancel?: Function) {
    const dialogRef = this.dialog.open(DialogOverviewDeleteOrganizationComponent, {
      data: { title, message, infrastructure, ok, cancel }, panelClass: this.darkModeService.darkMode ? 'darkMode' : 'lightMode'
    });
    return dialogRef;
  }

  // tslint:disable-next-line: ban-types
  openDialog(title?: string, message?: string, ok?: Function, cancel?: Function) {
    const dialogRef = this.dialog.open(DialogOverviewComponent, {
      data: { title, message, ok, cancel }, panelClass: this.darkModeService.darkMode ? 'darkMode' : 'lightMode'
    });
    return dialogRef;
  }

  openLoading() {
    const dialogRef = this.dialog.open(DialogOverviewComponent, {
      data: {}, panelClass: this.darkModeService.darkMode ? 'darkMode' : 'lightMode'
    });
    return dialogRef;
  }

  openDialogError(error?: string) {
    if (error) {
      this.translateService.get(['errors.error']).subscribe((values) => {
        this.openDialog(values['errors.error'], error, () => { });
      });
    } else {
      this.translateService.get(['errors.error', 'errors.error-message']).subscribe((values) => {
        this.openDialog(values['errors.error'], values['errors.error-message'], () => { });
      });
    }

  }

  savedCorrectly() {
    this.translateService.get(['alert.saved-correctly-title', 'alert.saved-correctly-message']).subscribe((values) => {
      this.openDialog(values['alert.saved-correctly-title'], values['alert.saved-correctly-message'], () => { });
    });
  }

  showErrorsBackend(err) {
    let params = {};
    const promises = [];
    if (err?.error?.error?.errorList) {
      err?.error?.error?.errorList.forEach((e) => {
        if (e.errorCode) {
          params = {};
          e.errorCode = 'errors.' + e.errorCode;
          if (e.params) {
            e.params.forEach(p => {
              if (params[e.errorCode + '.value']) {
                params[e.errorCode + '.valueAux'] = p;
              } else {
                params[e.errorCode + '.value'] = p;
              }
            });
          }
          promises.push(this.translateService.get(e.errorCode, params).toPromise());
        }
      });
    }

    Promise.all(promises).then((values) => {
      let text = '';
      values.forEach((element) => {
        text += element + '<br>';
      });
      this.translateService.get('errors.error').toPromise().then((val) => {
        this.openDialog(val, text);
      });
    });
  }
}
